import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import { ClipBoardService } from "../../../services/clipboard.service";

@Component({
  selector: "app-create-media-plan",
  templateUrl: "./create-media-plan.component.html",
  styleUrls: ["./create-media-plan.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CreateMediaPlanComponent implements OnInit {
  showComponentLoader = false;
  createMediaPlanForm: FormGroup;
  isSubmit = false;
  mediaPlanRequestData: any;
  quillConfig: any;
  btnStatus: any = true;
  authToken = localStorage.getItem("token");
  fileType: any;
  fileAttachedMediaplan: any = [];
  fileAttachedMediaplanUrls: any = [];
  discard = false;
  file_d:any;
  minNumInWords: any = '';
  minValuesWithCommaSystem: any;
  minValuesWithComma:any;
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateMediaPlanComponent>,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.mediaPlanRequestData = this.data;
   
    // console.log(d)
    // console.log("hi")
    this.setCreate();
  }

  ngOnInit() {
    this.initializeEditor();
  }
  valueInWords(event) {
    // debugger;
    
    let values = Number(this.removeCommas(event))
// debugger
    // if (type == 'minValue') {

        this.minValuesWithCommaSystem = values.toLocaleString('en-IN');

        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        this.minValuesWithComma = this.removeCommas(event);
        if ((this.minValuesWithComma = this.minValuesWithComma.toString()).length > 9) return 'overflow';
        this.minValuesWithComma = ('000000000' + this.minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!this.minValuesWithComma) return; var str = '';
        str += (this.minValuesWithComma[1] != 0) ? (a[Number(this.minValuesWithComma[1])] || b[this.minValuesWithComma[1][0]] + ' ' + a[this.minValuesWithComma[1][1]]) + 'crore ' : '';
        str += (this.minValuesWithComma[2] != 0) ? (a[Number(this.minValuesWithComma[2])] || b[this.minValuesWithComma[2][0]] + ' ' + a[this.minValuesWithComma[2][1]]) + 'lakh ' : '';
        str += (this.minValuesWithComma[3] != 0) ? (a[Number(this.minValuesWithComma[3])] || b[this.minValuesWithComma[3][0]] + ' ' + a[this.minValuesWithComma[3][1]]) + 'thousand ' : '';
        str += (this.minValuesWithComma[4] != 0) ? (a[Number(this.minValuesWithComma[4])] || b[this.minValuesWithComma[4][0]] + ' ' + a[this.minValuesWithComma[4][1]]) + 'hundred ' : '';
        str += (this.minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(this.minValuesWithComma[5])] || b[this.minValuesWithComma[5][0]] + ' ' + a[this.minValuesWithComma[5][1]]) + 'only ' : '';
        this.minNumInWords = str;          
        // console.log(this.minNumInWords)
    // }
  }
  close() {
    this.dialogRef.close();
  }
  save() {}
  setCreate() {
    this.createMediaPlanForm = this.fb.group({
      cpl: [null, Validators.required],
      min_ql: [null, Validators.required],
      max_ql: [null, Validators.required],
      media_plan_sheet: [],
      htmlText: [""],
    });
    if (this.mediaPlanRequestData.is_detailed_plan_required) {
      this.createMediaPlanForm
        .get("media_plan_sheet")
        .setValidators([Validators.required]);
    } else {
      this.createMediaPlanForm.get("media_plan_sheet").clearValidators();
    }
    this.createMediaPlanForm.get("media_plan_sheet").updateValueAndValidity();
  }
  get fCreate() {
    return this.createMediaPlanForm.controls;
  }
  removeCommas(value: any): string {
    if (!value) return "0";
    return typeof value === "string"
      ? value.replace(/,/g, "")
      : value.toString();
  }
  create() {
    this.showComponentLoader = true;
    this.isSubmit = true;
    if (this.createMediaPlanForm.invalid) {
      this.showComponentLoader = false;
      return;
    }
    this.createMediaPlanForm.value.cpl = this.removeCommas(
      this.createMediaPlanForm.value.cpl
    );
    this.createMediaPlanForm.value.min_ql = this.removeCommas(
      this.createMediaPlanForm.value.min_ql
    );
    this.createMediaPlanForm.value.max_ql = this.removeCommas(
      this.createMediaPlanForm.value.max_ql
    );
    // let body = {}
    let formData = new FormData();

    formData.append("media_plan_request_id", this.mediaPlanRequestData.id);
    formData.append("cpl", this.createMediaPlanForm.value.cpl);
    formData.append("min_ql",  this.createMediaPlanForm.value.min_ql);
    formData.append("max_ql", this.createMediaPlanForm.value.max_ql);
    formData.append("remarks", this.createMediaPlanForm.value.htmlText);
  
    if(this.fileAttachedMediaplan.length != 0){
      const pitchBlob = new Blob([this.fileAttachedMediaplan[0]], { type: this.fileAttachedMediaplan[0].type });

      formData.append("plan_sheet", pitchBlob, this.fileAttachedMediaplan[0].name);
    }
    let url = "media_plan";
    this.serverService
      .createMediaPlanRequest(url, formData, this.authToken)
      .subscribe(
        (data) => {
          this.isSubmit = false;
          this.btnStatus = false;
          this.showComponentLoader = false;
          this.clipBoardService.showMessgeInText(
            "Media Plan Created Successfully",
            "success-snackbar"
          );
          this.dialogRef.close(data);
        },
        (err) => {
          this.btnStatus = false;
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }
  CommaInNumber(value: any, field_name: any) {
    if(field_name == 'cpl'){
      this.valueInWords(value)
    }
    
    if (!value) return;
    let rawValue = value.replace(/,/g, "");
    let number = Number(rawValue);
    if (isNaN(number)) return;
    let formattedValue = number.toLocaleString("en-IN");
    this.createMediaPlanForm
      .get(field_name)
      .patchValue(formattedValue, { emitEvent: false });
  }
  initializeEditor() {
    this.quillConfig = {
      //toolbar: '.toolbar',
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          //[{ 'direction': 'rtl' }],                         // text direction
          [{ size: ["small", false, "large", "huge"] }],
          //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          //[{ 'color': [] }, { 'background': [] }],
          [{ font: [] }],
          [{ align: [] }],
          ["clean"],
          ["link"],
          //['link', 'image', 'video']
        ],
      },

      imageResize: {
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },

      "emoji-toolbar": true,
      "emoji-textarea": false,
      "emoji-shortname": true,

      keyboard: {
        bindings: {
          shiftEnter: {
            key: 13,
            shiftKey: true,
            handler: (range, context) => {
              // Handle shift+enter
              //console.log("shift+enter")
            },
          },
          enter: {
            key: 13,
            handler: (range, context) => {
              //console.log("enter");
              return true;
            },
          },
        },
      },
    };
  }
  onContentChanged = (event) => {
    //console.log('onContentChanged ', event.html);

    // this.salePersonList = this.commentSalePersonList

    //var myString = '<p><span class="mention" data-index="0" data-denotation-char="@" data-id="1099" data-value="testSatol"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>testSatol</span></span> <span class="mention" data-index="1" data-denotation-char="@" data-id="1087" data-value="inaam user12"><span contenteditable="false"><span class="ql-mention-denotation-char">@</span>inaam user12</span></span> </p>';

    if (
      this.createMediaPlanForm.value.htmlText != null &&
      this.createMediaPlanForm.value.htmlText != ""
    ) {
      var regex = /data-id="([^"]+)"/g;
      var matches = event.html.match(regex);
      var dataIds = [];

      if (matches) {
        matches.map(function (match) {
          //return match.match(/data-id="([^"]+)"/)[1];
          dataIds.push(Number(match.match(/data-id="([^"]+)"/)[1]));
        });

        // this.dataIdsArr = dataIds

        var arr2Ids: any = new Set(dataIds.map((item) => item));
        //console.log(arr2Ids)

        // var result = this.salePersonList.filter(
        //   (item) => !arr2Ids.has(item.id)
        // );
        //console.log(result)

        // this.salePersonList = result;
        //console.log(this.salePersonList)
        //console.log('data-ids:', dataIds);
      } else {
        //console.log('No data-id attributes found');
      }
    }

    this.createMediaPlanForm.value.htmlText = event.html;

  };
  onFileSelected(event: any) {
 
      this.fileType = "";
      const input = event.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const files = Array.from(input.files);
        const MAX_FILE_SIZE = 100 * 1024 * 1024;
        files.forEach((file) => {
          if (file.size > MAX_FILE_SIZE) {
            // Show error message and skip this file
            this.clipBoardService.showMessgeInText(
              `File "${file.name}" exceeds the maximum allowed size of 100MB.`,
              "error-snackbar"
            );
            input.value = "";
            return;
          }
          const reader = new FileReader();
          reader.onload = () => {
            this.file_d = new Date()
            this.fileAttachedMediaplan.push(file);
            this.fileAttachedMediaplanUrls.push(reader.result);
            // this.changeDetectorRef.detectChanges();

          };
          reader.readAsDataURL(file);
        });
        input.value = "";
        // console.log(this.brochureFiles)
      }
    
  }
  discardFile() {
    this.createMediaPlanForm
    .get("media_plan_sheet").patchValue(null)
    this.fileAttachedMediaplan.splice(0, 1);
    this.fileAttachedMediaplanUrls.splice(0, 1);
    this.file_d = null
   
  }
}